// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21.9902 7.1416L19.8672 22L12.7334 21.999L15 11L18 11L12 5L11.5 8L6 8L8 11H11L8.7334 21.999H1.88281L4.10449 2L17.4883 2L22.0596 6.65137L21.9902 7.1416Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-wechat-workdocs-filled')
export default class LogoWechatWorkdocsFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-wechat-workdocs-filled',
    }
  }
}
